module.exports = __webpack_public_path__ + "media/icons/sentiment_neutral-56e23f37.svg";